/**
 * カレンダー連携スコープ不足時のエラーハンドラ
 * - API 403 時
 * - PrivateLayout で GET /api/settings/calendars が 200 かつ一覧空のとき（DB にカレンダーが無い＝再連携が必要な状態の典型）
 * いずれもモーダル表示用イベントを初回だけ発火する。
 */
export const CALENDAR_SCOPE_ERROR_EVENT = 'calendar-scope-permission-missing';

/** FirstTimeExperienceTutorial のツールチップ (100001) より手前。初回オンボーディングと同時でも再連携を優先する。 */
export const CALENDAR_SCOPE_ERROR_MODAL_Z_INDEX = 100_050;

let hasNotifiedScopeError = false;

export const notifyCalendarScopeError = () => {
    if (typeof window === 'undefined') return;
    if (hasNotifiedScopeError) return;
    hasNotifiedScopeError = true;
    window.dispatchEvent(new CustomEvent(CALENDAR_SCOPE_ERROR_EVENT));
};
